import { useMemo, useState } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useInputAction } from '~/rage';
import {
	IModalReplyWithValue,
	IModalStateCountAndPrice,
	InputAction,
	WalletType,
	walletTypeCurrency,
} from '~/shared';
import { CurrencyIcon } from '../../CurrencyIcon';
import { Counter } from '../Counter';
import { ModalButton } from '../ModalButton';
import {
	StyledButtonsContainer,
	StyledModalBody,
	StyledPrice,
	StyledRow,
} from './ModalCountAndPrice.styled';

const ModalCountAndPrice: React.FC<{ state: IModalStateCountAndPrice }> = ({
	state,
}) => {
	const [count, setCount] = useState(state?.count || 0);
	const currencyIcon = useWalletIcon(
		walletTypeCurrency[state?.wallet],
		state?.wallet === WalletType.Donate,
	);

	const isDonate = useMemo(
		() => state?.wallet === WalletType.Donate,
		[state?.wallet],
	);

	const price = useMemo(
		() => (count || 1) * (state?.pricePerItem || 0),
		[state, count],
	);

	useInputAction(InputAction.CommonMenuAccept, () => {
		rage.modal.replyToCurrentModal({
			isAccepted: true,
			value: count || 1,
		} as IModalReplyWithValue<number>);
	});

	useInputAction(InputAction.CommonMenuClose, () => {
		rage.modal.replyToCurrentModal({
			isAccepted: false,
		});
	});

	return (
		<StyledModalBody>
			{state?.text && (
				<Text style={{ fontSize: 16, color: '#ffffff', opacity: 0.75 }}>
					{state?.text}
				</Text>
			)}
			<StyledRow>
				<Text style={{ fontSize: 18, color: '#ffffff', opacity: 0.25 }}>
					Выберите кол-во
				</Text>
				<Counter
					count={count}
					minCount={state?.minCount || 0}
					maxCount={state?.maxCount || 0}
					onChange={setCount}
				/>
			</StyledRow>
			<Divider $direction={'H'} $color={'rgba(255,255,255,0.1)'} />
			<StyledRow>
				<Text style={{ fontSize: 18, color: '#ffffff', opacity: 0.25 }}>
					Стоимость
				</Text>
				<StyledPrice>
					<Text>{price?.toLocaleString('ru-RU')}</Text>
					<CurrencyIcon icon={currencyIcon} size={isDonate ? 'md' : 'sm'} />
				</StyledPrice>
			</StyledRow>
			<StyledButtonsContainer>
				<ModalButton
					$type={state?.cancelButton.color}
					onClick={() => {
						rage.modal.replyToCurrentModal({ isAccepted: false });
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					{state?.cancelButton.text}
				</ModalButton>
				<ModalButton
					$type={state?.acceptButton.color}
					onClick={() => {
						rage.modal.replyToCurrentModal({
							isAccepted: true,
							value: count,
						} as IModalReplyWithValue<number>);
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					{state?.acceptButton.text}
				</ModalButton>
			</StyledButtonsContainer>
		</StyledModalBody>
	);
};

export { ModalCountAndPrice };
